export default class BlockPromoText extends Core.BlockComponent {
  constructor(el, context) {
    super(el, context);

    this.contentArea = el.querySelector('[data-content-area]');
  }

  get blockHeight() {
    const {
      paddingTop: containerPaddingTop,
      paddingBottom: containerPaddingBottom,
    } = getComputedStyle(this.el);
    const paddingTopInt = Number(containerPaddingTop.replace('px', ''));
    const paddingBottomInt = Number(containerPaddingBottom.replace('px', ''));
    return `${this.contentArea.offsetHeight + paddingTopInt + paddingBottomInt}px`;
  }
}
